import { type CsvDataRow, UNKNOWN_DEVICE } from '@pitbrain/shared'
import useApi from '../../../api/useApi'
import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { GPS_ONLY_FEATURES, useCreateSession } from '../useCreateSession'
import { rawTelemetryFromKmhRows } from '../gpsReadings'
import { type UploadFormat } from '../UploadFormat'

const withoutAltitude = ({ altitude: _altitude, ...row }: CsvDataRow) => row

export const useCsvProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const createSession = useCreateSession(api)

  const processFile = async (file: File, sessionId: string) => {
    const results = await api.fileApi.convertCsvFile(file)
    const rawTelemetry = rawTelemetryFromKmhRows(
      results.map(withoutAltitude),
      UNKNOWN_DEVICE
    )
    await createSession(rawTelemetry, {
      sessionId,
      fileName: file.name,
      device: UNKNOWN_DEVICE,
      sessionFeatures: GPS_ONLY_FEATURES,
    })
  }

  return {
    extensions: ['.CSV'],
    keepsFileAsSource: true,
    processFile,
    error: api.error,
  }
}
